import { Box, Button, styled, Theme, Typography, createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MediaItem = styled('img')(({ theme }) => ({
  maxHeight: 120,
  borderRadius: 8,
}));

export const ImageContainer = styled('div')(({ theme }) => ({
  '& > img': {
    maxHeight: 144,
    minWidth: 50,
    minHeight: 144,
    margin: '0 10px 10px 0',
    borderRadius: 8,
    cursor: 'pointer',
    transition: '0.2s',

    '&:hover': {
      opacity: 0.8,
    },
  },
}));

export const FileItem = styled('div')(({ theme }) => ({
  background: theme.palette.type === 'dark' ? '#1f2733' : COLORS.LIGHT,
  width: '100%',
  height: 46,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  padding: '10px 15px',
  cursor: 'pointer',
  maxWidth: 200,
  '& > p': {
    maxWidth: 200,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20,
    marginRight: 7,

    '& svg path': {
      fill: '#3e8bff',
    },
  },
}));

export const MainContainer = styled('div')(({ theme }) => ({
  background: '#0b0f14',
  border: '1px solid #2d343e',
  borderRadius: 8,
  padding: '25px 30px',
  width: '100%',
  position: 'relative',
  [theme.breakpoints.down('xs')]: {
    padding: 15,
  },

  '& svg': {
    width: 30,
    height: 30,

    '& path': {
      fill: COLORS.PRIMARY,
    },
  },
}));

export const Heading = styled(Typography)({
  position: 'relative',
  borderBottom: '1px solid #2d343e',
  alignItems: 'center',
  paddingBottom: 15,
  margin: '0 0 20px',
  fontSize: 18,

  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
});

export const DueCont = styled(Box)(({ theme }) => ({
  margin: '-5px 0 20px',
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 33%)',
  gap: 15,
  width: '100%',

  [theme.breakpoints.down(1250)]: {
    gridTemplateColumns: 'repeat(2, 50%)',
    width: `calc(100% - ${15}px)`,
  },

  [theme.breakpoints.down(900)]: {
    gridTemplateColumns: 'unset',
    width: '100%',
  },
}));

export const DuedateTextCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginLeft: 10,
  flexDirection: 'column',
}));

export const ButtonCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },

  '& > button:nth-child(2)': {
    margin: '0 20px 0 20px',
    [theme.breakpoints.down(960)]: {
      margin: '20px 0 20px 0',
    },
  },
}));

export const ResponseButton = styled(Button)<
  Theme,
  { active: boolean; design: 'positive' | 'neutral' | 'negative' | 'unset' }
>(({ theme, design, active }) => ({
  borderColor: design === 'negative' ? COLORS.ERROR : design === 'positive' ? COLORS.PASS : COLORS.WARNING,
  width: 335,
  height: 50,
  borderRadius: 8,
  borderStyle: 'solid',
  borderWidth: 1,
  background: active
    ? design === 'negative'
      ? COLORS.ERROR
      : design === 'positive'
        ? COLORS.PASS
        : COLORS.WARNING
    : 'unset',

  '&:hover': {
    backgroundColor: design === 'negative' ? COLORS.ERROR : design === 'positive' ? COLORS.PASS : COLORS.WARNING,
  },
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  background: COLORS.PRIMARY,
  width: '100%',
  height: 50,
  marginTop: 20,
}));

export const NoteCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 20,
}));

export const SectionCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: COLORS.PRIMARY,
}));

// ST LAYOUT

export const ScrollableContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 20,
  paddingBottom: 10,
  width: 'auto',
  maxHeight: 300,
  overflowY: 'auto',
  paddingRight: 10,
  marginTop: 15,
  flexWrap: 'wrap',
}));

export const PlainHeading = styled(Typography)({
  marginBottom: 5,
});

export const MediaList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,

  '& > p': {
    display: 'flex',
    alignItems: 'center',
    '&:before': {
      content: '"○"',
      lineHeight: 1,
      color: '#f7bc02',
      width: 14,
      height: 'auto',
      fontSize: 24,
      margin: '0 10px 2px 0',
    },
  },
}));

export const Mediacont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 50,
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
    gap: 20,
  },
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    toolTip: {
      background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
      boder: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
    },
  }),
);
